import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { ReactNode } from 'react';
import { Address } from 'viem';
import { useAccount } from 'wagmi';
import { atomWalletModal } from '~/blinko/modals/wallet.modal';

interface WalletSlotProps {
  children: ({ 
    address, 
    connected, 
    connect 
  }: { 
    address: Address, 
    connected: boolean, 
    isConnecting: boolean, 
    connect: () => void 
  }) => ReactNode;
}

const WalletSlot: React.FC<WalletSlotProps> = ({ children }) => {
  const { address, status } = useAccount()

  const setVisible = useSetAtom(atomWalletModal.visible)
  const isSigned = useAtomValue(atomWalletModal.isSigned)

  const connectWallet = () => {
    if (status === 'reconnecting')
      return
    setVisible(true)
  }

  return children({ 
    address, 
    connected: Boolean(isSigned), 
    isConnecting: status === 'connecting' || status === 'reconnecting', 
    connect: connectWallet 
  })
};

export default WalletSlot;
